const getMinSelectionOptions = (appliedRange, range, increment) => {
  const minOptions = [];
  const minOptionForUserToSelect = range.min - (range.min % increment);
  const maxOptionForUserToSelect = appliedRange?.max ?? range.max;

  for (let i = minOptionForUserToSelect, l = maxOptionForUserToSelect; i < l; i += increment) {
    minOptions.push(`${i}`);
  }

  return minOptions;
};

export default getMinSelectionOptions;
